export const environment = {
  production: false,
  //baseUrl: 'https://api.pestwareapp.com/administrative',
  //s3Url: 'https://pestware-storage-prod.s3.amazonaws.com/',

  baseUrl: 'https://api-dev.pestforceapp.com/administrative',
  staffUrl: 'https://api-dev.pestforceapp.com/staff',
  // baseUrl: 'http://127.0.0.1:8000/administrative',

  StaffLogin: 'https://api-dev.pestforceapp.com/staff/',
  s3Url: 'https://pestware-storage-devs.s3.amazonaws.com/',
  s3UrlQuotes: 'https://pestware-storage-devs.s3.us-east-1.amazonaws.com/',

  webSocketUrl: 'wss://api-dev.pestforceapp.com/ws/',

  firebaseConfig: {
    apiKey: "AIzaSyDhtkwCTCIbMJR2Vn5gr6KaDFa-3jrw3wI",
    authDomain: "pestforce-63f66.firebaseapp.com",
    projectId: "pestforce-63f66",
    storageBucket: "pestforce-63f66.firebasestorage.app",
    messagingSenderId: "187913910356",
    appId: "1:187913910356:web:7ab35d8735e6f3983395c1",
  },
  vapidKey: "BHSJAud_ksSOoozodSvgMjqJ4g9VXPYKddvYmfm_M2-w2l5W5LmpBbAy_HaPF3eJC2JR9ZMjKBsqHPJqk7rXXwM"
};
